module.exports = __webpack_public_path__ + "static/img/ic_code.c1fee24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/ic_code.png
// module id = 4tG1
// module chunks = 1